import React, {FC, useState} from 'react'
import {Formik, Form, Field, FormikErrors} from 'formik'
import {Input} from '../../../../../_metronic/partials/controls'
import {useIntl} from 'react-intl'
import {RegisterUserRequest} from '../../../../../redux/reducers/auth/types'
import * as Yup from 'yup'
import axios from 'axios'
import {KTSVG} from '../../../../../_metronic/helpers'
export interface submitGeneralInformationFormProps {
  firstName: string
  lastName: string
  email: string
  phone: string
  password: string
  gender: string
}

interface GeneralInformationProps {
  onSubmit: (vals: submitGeneralInformationFormProps) => void
  user: RegisterUserRequest
  btnRef: any
  setLoading: (val: boolean) => void
}
const GeneralInformation: FC<GeneralInformationProps> = ({onSubmit, btnRef, user, setLoading}) => {
  const intl = useIntl()
  const [initErrors, setInitError] = React.useState<
    FormikErrors<submitGeneralInformationFormProps>
  >({})
  const [emailValiadated, setEmailValidated] = React.useState(false)
  const schema = Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    lastName: Yup.string()
      .trim()
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    email: Yup.string()
      .email(intl.formatMessage({id: 'FORM.ERROR.EMAIL.WRONG_FORMAT'}))
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    phone: Yup.string()
      .trim()
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    password: Yup.string()
      .trim()
      .min(6, intl.formatMessage({id: 'FORM.ERROR.SYMBOL.MIN'}, {min: 3}))
      .max(50, intl.formatMessage({id: 'FORM.ERROR.SYMBOL.MAX'}, {max: 50}))
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    repeatPassword: Yup.string()
      .trim()
      .oneOf([Yup.ref('password')], intl.formatMessage({id: 'FORM.ERROR.PASSWORD_DOES_NOT_MATCH'}))
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
  })

  const submit = async (vals: submitGeneralInformationFormProps) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL
      setLoading(true)
      const res = await axios.post(`${API_URL}/api/users/verify-mail-exist`, {
        email: vals.email,
      })

      const data = res.data
      if (data.exist) {
        setInitError({email: intl.formatMessage({id: 'FORM.ERROR.EMAIL.EXIST'})})
        setEmailValidated(false)
      } else {
        setEmailValidated(true)
        setInitError({})
      }
      setLoading(false)
      onSubmit(vals)
    } catch (error) {
      setLoading(false)
    }
  }

  const [showPasswords, setShowPasswords] = useState({
    password: false,
    repeatPassword: false,
  })

  return (
    <Formik
      validationSchema={schema}
      validateOnBlur
      initialValues={{
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone,
        gender: user.gender,
        password: user.password,
      }}
      onSubmit={submit}
    >
      {({errors, setFieldError, handleSubmit, setFieldValue}) => {
        if (
          initErrors.email &&
          initErrors.email.trim() !== '' &&
          !errors.email &&
          errors.email !== initErrors.email
        ) {
          setFieldError('email', initErrors.email)
        }
        if (emailValiadated) {
          setFieldError('email', undefined)
          setEmailValidated(false)
        }

        return (
          <Form>
            <div className='row'>
              <div className='col-sm'></div>
              <h2 className='fw-bolder d-flex align-items-center text-dark'>
                {intl.formatMessage({id: 'MENU.GENERAL_INFORMATION'})}
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Billing is issued based on your selected account type'
                ></i>
              </h2>
              <div className='text-gray-400 fw-bold fs-6'>
                {intl.formatMessage({id: 'MENU.GENERAL_INFORMATION_DESC'})}
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-6'>
                <Field
                  label={intl.formatMessage({id: 'INPUT.FIRST_NAME.LABEL'})}
                  placeholder={intl.formatMessage({id: 'INPUT.FIRST_NAME.PLACEHOLDER'})}
                  name='firstName'
                  component={Input}
                  required={true}
                />
              </div>
              <div className='col-sm-12 col-md-6'>
                <Field
                  label={intl.formatMessage({id: 'INPUT.LAST_NAME.LABEL'})}
                  placeholder={intl.formatMessage({id: 'INPUT.LAST_NAME.PLACEHOLDER'})}
                  name='lastName'
                  component={Input}
                  required={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-6'>
                <Field
                  label={intl.formatMessage({id: 'INPUT.EMAIL.LABEL'})}
                  placeholder={intl.formatMessage({id: 'INPUT.EMAIL.PLACEHOLDER'})}
                  name='email'
                  component={Input}
                  required={true}
                />
              </div>
              <div className='col-sm-12 col-md-6'>
                <Field
                  label={intl.formatMessage({id: 'INPUT.PHONE.LABEL'})}
                  placeholder={intl.formatMessage({id: 'INPUT.PHONE.PLACEHOLDER'})}
                  name='phone'
                  component={Input}
                  required={true}
                />
              </div>
            </div>
            <Field name='gender'>
              {() => (
                <div className='row'>
                  <div className='col-sm d-flex gap-3 my-4'>
                    <div className='form-check form-check-custom form-check-solid form-check-sm'>
                      <input
                        className='form-check-input'
                        name='gender'
                        type='radio'
                        value='male'
                        id='maleRadio'
                        onChange={(e) => {
                          setFieldValue('gender', e.target.value)
                        }}
                      />
                      <label className='form-check-label' htmlFor='maleRadio'>
                        {intl.formatMessage({id: 'MENU.MALE'})}
                      </label>
                    </div>
                    <div className='form-check form-check-custom form-check-solid form-check-sm'>
                      <input
                        className='form-check-input'
                        name='gender'
                        type='radio'
                        value='female'
                        id='femaleRadio'
                        onChange={(e) => {
                          setFieldValue('gender', e.target.value)
                        }}
                      />
                      <label className='form-check-label' htmlFor='femaleRadio'>
                        {intl.formatMessage({id: 'MENU.FEMALE'})}
                      </label>
                    </div>
                  </div>
                </div>
              )}
            </Field>

            <div className='row'>
              <div className='col-sm'>
                <Field
                  label={intl.formatMessage({id: 'INPUT.PASSWORD.LABEL'})}
                  placeholder={intl.formatMessage({id: 'INPUT.PASSWORD.PLACEHOLDER'})}
                  name='password'
                  component={Input}
                  required={true}
                  rightInputAction={
                    showPasswords.password ? (
                      <a
                        className='_cursor-pointer'
                        onClick={() =>
                          setShowPasswords({
                            ...showPasswords,
                            password: !showPasswords.password,
                          })
                        }
                      >
                        <KTSVG
                          path='/media/svg/stolen/Visible.svg'
                          className='svg-icon-2x svg-icon-white'
                        />
                      </a>
                    ) : (
                      <a
                        className='_cursor-pointer'
                        onClick={() =>
                          setShowPasswords({
                            ...showPasswords,
                            password: !showPasswords.password,
                          })
                        }
                      >
                        <KTSVG
                          path='/media/svg/stolen/Hidden.svg'
                          className='svg-icon-2x svg-icon-white'
                        />
                      </a>
                    )
                  }
                  type={showPasswords.password ? 'text' : 'password'}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-sm'>
                <Field
                  label={intl.formatMessage({id: 'INPUT.REPEAT_PASSWORD.LABEL'})}
                  placeholder={intl.formatMessage({id: 'INPUT.REPEAT_PASSWORD.PLACEHOLDER'})}
                  name='repeatPassword'
                  component={Input}
                  required={true}
                  rightInputAction={
                    showPasswords.repeatPassword ? (
                      <a
                        className='_cursor-pointer'
                        onClick={() =>
                          setShowPasswords({
                            ...showPasswords,
                            repeatPassword: !showPasswords.repeatPassword,
                          })
                        }
                      >
                        <KTSVG
                          path='/media/svg/stolen/Visible.svg'
                          className='svg-icon-2x svg-icon-white'
                        />
                      </a>
                    ) : (
                      <a
                        className='_cursor-pointer'
                        onClick={() =>
                          setShowPasswords({
                            ...showPasswords,
                            repeatPassword: !showPasswords.repeatPassword,
                          })
                        }
                      >
                        <KTSVG
                          path='/media/svg/stolen/Hidden.svg'
                          className='svg-icon-2x svg-icon-white'
                        />
                      </a>
                    )
                  }
                  type={showPasswords.repeatPassword ? 'text' : 'password'}
                />
              </div>
            </div>
            <button
              style={{display: 'none'}}
              type='submit'
              ref={btnRef}
              onSubmit={() => handleSubmit()}
            />
          </Form>
        )
      }}
    </Formik>
  )
}

export default GeneralInformation
